import {createStyles, Theme} from "@material-ui/core";

export const LandingStyle = (theme: Theme) => createStyles({
    root: {
        width: '100%',
        position: 'relative',

        '& > *': {
            boxSizing: "border-box",
        },
    },
    background: {
        position: 'absolute',
        overflow: 'hidden',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        minHeight: '100vh',
        zIndex: -1,
        backgroundColor: theme.palette.background.default,
    },
    backgroundImgCornerBottomLeft: {
        position: 'absolute',
        bottom: 0,
        left: 0,
    },
    backgroundImgCornerTopRight: {
        position: 'absolute',
        top: 0,
        right: 0,
    },
    container: {
        width: '100%',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        padding: theme.spacing(6.5),
    },
    languageSelect: {
        position: 'absolute',
        top: theme.spacing(6.5),
        right: theme.spacing(6.5),
        zIndex: 3,
    },
    topContent: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
        marginBottom: theme.spacing(2.5),
    },
    middleContent: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        gap: theme.spacing(2),
        marginTop: theme.spacing(2.5),
        marginBottom: theme.spacing(2.5),
    },
    bottomContent: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-top',
        gap: theme.spacing(3),
        marginTop: theme.spacing(2.5),
    },
    footer: {
        display:'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        marginTop: theme.spacing(2.5),
    },
});



// WEBPACK FOOTER //
// ./src/components/landing/landing.style.ts